// third-party
import { presetPalettes } from '@ant-design/colors';

// project imports
import ThemeOption from './theme';
import { extendPaletteWithChannels } from 'utils/colorUtils';
import { THEME_COLOR_CONFIG } from 'config/themeColors';

// ==============================|| GREY COLORS BUILDER ||============================== //

function buildGrey() {
  const { primary, ascent, constant } = THEME_COLOR_CONFIG.grey;

  return [...primary, ...ascent, ...constant];
}

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export function buildPalette(presetColor) {
  const lightColors = { ...presetPalettes, grey: buildGrey() };
  const lightPaletteColor = ThemeOption(lightColors, presetColor);

  const commonColor = { common: THEME_COLOR_CONFIG.common };

  const extendedLight = extendPaletteWithChannels(lightPaletteColor);
  const extendedCommon = extendPaletteWithChannels(commonColor);

  const light = {
    mode: 'light',
    ...extendedCommon,
    ...extendedLight,
    text: {
      primary: extendedLight.grey[700],
      secondary: extendedLight.grey[500],
      disabled: extendedLight.grey[400]
    },
    action: { disabled: extendedLight.grey[300] },
    divider: extendedLight.grey[200],
    background: {
      paper: extendedLight.grey[0],
      default: extendedLight.grey.A50
    }
  };

  const g = extendedLight.grey;
  const dark = {
    mode: 'dark',
    ...extendedCommon,
    ...extendedLight,
    text: {
      primary: g[0],
      secondary: g[400],
      disabled: g[600]
    },
    action: { disabled: g[700] },
    divider: g[800],
    background: {
      default: g[900],
      paper: g[800]
    }
  };

  return {
    light,
    dark
  };
}
